// extracted by mini-css-extract-plugin
module.exports = {"WrapperDetail":"privacy-policy_WrapperDetail__nyPZ3"};